import Vue from 'vue'
import VueRouter from 'vue-router'

import Preload from './pages/Preload'

// Main pages
import Start from './pages/Start'
import Game from './pages/Game'

import PhagwaStart from './pages/phagwa/PhagwaStart'
import PhagwaGame from './pages/phagwa/PhagwaGame'

import KerstmisStart from './pages/kerstmis/KerstmisStart'
import KerstmisMenu1 from './pages/kerstmis/KerstmisMenu1'
import KerstmisMenu2 from './pages/kerstmis/KerstmisMenu2'
import KerstmisGame from './pages/kerstmis/KerstmisGame'
import KerstmisOrnament from './pages/kerstmis/KerstmisOrnament'

import ChineesStart from './pages/chinees/ChineesStart'
import ChineesGame from './pages/chinees/ChineesGame'
import ChineesGameEasy from './pages/chinees/ChineesGameEasy'
import ChineesIntro from './pages/chinees/ChineesIntro'
import ChineesHoro from './pages/chinees/ChineesHoro'

import MarronsStart from './pages/marrons/MarronsStart'
import MarronsGame from './pages/marrons/MarronsGame'
import MarronsIntro from './pages/marrons/MarronsIntro'

import InheemsStart from './pages/inheems/InheemsStart'
import InheemsMenu from './pages/inheems/InheemsMenu'
import InheemsGame from './pages/inheems/InheemsGame'
import InheemsIntro from './pages/inheems/InheemsIntro'

import EidStart from './pages/eid/EidStart'

import KeukenStart from './pages/keuken/KeukenStart'

import VrijhedenStart from './pages/vrijheden/VrijhedenStart'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   redirect:
  //   {
  //     name: 'Home'
  //   }
  // },
  {
    path: '/start',
    name: 'Start',
    component: Start
  },
  {
    path: '/game',
    name: 'Game',
    component: Game
  },
  {
    path: '/phagwa/start',
    name: 'PhagwaStart',
    component: PhagwaStart
  },
  {
    path: '/phagwa/game',
    name: 'PhagwaGame',
    component: PhagwaGame
  },
  {
    path: '/kerstmis/start',
    name: 'KerstmisStart',
    component: KerstmisStart
  },
  {
    path: '/kerstmis/menu/1',
    name: 'KerstmisMenu1',
    component: KerstmisMenu1
  },
  {
    path: '/kerstmis/menu/2',
    name: 'KerstmisMenu2',
    component: KerstmisMenu2
  },
  {
    path: '/kerstmis/game',
    name: 'KerstmisGame',
    component: KerstmisGame
  },
  {
    path: '/kerstmis/ornament',
    name: 'KerstmisOrnament',
    component: KerstmisOrnament
  },
  {
    path: '/chinees/start',
    name: 'ChineesStart',
    component: ChineesStart
  },
  {
    path: '/chinees/game',
    name: 'ChineesGame',
    component: ChineesGame
  },
  {
    path: '/chinees/game/easy',
    name: 'ChineesGameEasy',
    component: ChineesGameEasy
  },
  {
    path: '/chinees/intro',
    name: 'ChineesIntro',
    component: ChineesIntro
  },
  {
    path: '/chinees/horo',
    name: 'ChineesHoro',
    component: ChineesHoro
  },
  {
    path: '/marrons/start',
    name: 'MarronsStart',
    component: MarronsStart
  },
  {
    path: '/marrons/game',
    name: 'MarronsGame',
    component: MarronsGame
  },
  {
    path: '/marrons/intro',
    name: 'MarronsIntro',
    component: MarronsIntro
  },
  {
    path: '/inheems/start',
    name: 'InheemsStart',
    component: InheemsStart
  },
  {
    path: '/inheems/menu',
    name: 'InheemsMenu',
    component: InheemsMenu
  },
  {
    path: '/inheems/intro',
    name: 'InheemsIntro',
    component: InheemsIntro
  },
  {
    path: '/inheems/game',
    name: 'InheemsGame',
    component: InheemsGame
  },
  {
    path: '/eid/start',
    name: 'EidStart',
    component: EidStart
  },
  {
    path: '/keuken/start',
    name: 'KeukenStart',
    component: KeukenStart
  },
  {
    path: '/vrijheden/start',
    name: 'VrijhedenStart',
    component: VrijhedenStart
  },
  {
    path: '/preload',
    name: 'Preload',
    component: Preload
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
